/**
 * @generated SignedSource<<1a0ba9fad82753812ee745732f7ed5e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type morningStudioArticleFooterDisplayQuery$data = {
  readonly article: {
    readonly entityId: string;
    readonly seriesContainer: {
      readonly headline: string | null | undefined;
      readonly series: ReadonlyArray<{
        readonly entityId?: string;
        readonly " $fragmentSpreads": FragmentRefs<"morningStudioContentItemContent">;
      } | null | undefined> | null | undefined;
      readonly socialHeadline: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
    } | null | undefined;
    readonly topics: ReadonlyArray<{
      readonly entityId: string;
      readonly sponsor: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsMainTopicContent">;
  };
  readonly topic?: {
    readonly contents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityId: string;
          readonly " $fragmentSpreads": FragmentRefs<"morningStudioContentItemContent">;
        };
      }>;
    } | null | undefined;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  };
  readonly " $fragmentType": "morningStudioArticleFooterDisplayQuery";
};
export type morningStudioArticleFooterDisplayQuery$key = {
  readonly " $data"?: morningStudioArticleFooterDisplayQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"morningStudioArticleFooterDisplayQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "entityLink"
},
v3 = [
  (v0/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "morningStudioContentItemContent"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "applicationId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "articleTypeId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityUuid"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "scmpPlusPaywallTypeIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "topicEntityUuid"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "withTopic"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "morningStudioArticleFooterDisplayQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityUuid",
              "variableName": "entityUuid"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "article",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Sponsor",
              "kind": "LinkedField",
              "name": "sponsor",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckIsMainTopicContent",
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Topic",
                  "kind": "LinkedField",
                  "name": "topics",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Article",
          "kind": "LinkedField",
          "name": "seriesContainer",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "socialHeadline",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "headline",
              "storageKey": null
            },
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "series",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": (v3/*: any*/),
                  "type": "Content",
                  "abstractKey": "__isContent"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "withTopic",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "fields": [
                {
                  "kind": "Variable",
                  "name": "entityUuid",
                  "variableName": "topicEntityUuid"
                }
              ],
              "kind": "ObjectValue",
              "name": "filter"
            }
          ],
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "topic",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": [
                {
                  "fields": [
                    {
                      "items": [
                        {
                          "kind": "Variable",
                          "name": "articleTypeIds.0",
                          "variableName": "articleTypeId"
                        }
                      ],
                      "kind": "ListValue",
                      "name": "articleTypeIds"
                    },
                    {
                      "kind": "Variable",
                      "name": "paywallTypeIds",
                      "variableName": "scmpPlusPaywallTypeIds"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "exclude"
                },
                {
                  "fields": [
                    {
                      "items": [
                        {
                          "kind": "Variable",
                          "name": "applicationIds.0",
                          "variableName": "applicationId"
                        }
                      ],
                      "kind": "ListValue",
                      "name": "applicationIds"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "filter"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 10
                }
              ],
              "concreteType": "ContentConnection",
              "kind": "LinkedField",
              "name": "contents",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "41a2f6379c25e7425debe1cf3359ec5c";

export default node;
